export default "__VITE_ASSET__BWS6zq_O__"